import * as React from 'react';
import { render } from 'react-dom';
import * as moment from 'moment';
import { createCalendarStore, ICalendarSettings, ICalendarState, CalendarActions } from '@adage/ace-calendar';
import { Provider } from 'react-redux';
import { IArenaEvent } from './classes/event';
import ExampleComp from './ex-comp';
import App from './components/app'; 
import * as stickyfill from 'stickyfilljs';


const element = document.getElementById("calendar-entry-js")
const numberOfMonth = Number(element.getAttribute("data-number-of-month"))
let defaultState: ICalendarState<IArenaEvent> = {

    updating: false,
    specificDates: false,
    extendEvents: false,
    startDate: moment().clone().startOf("day"),
    endDate: moment().clone().endOf('month').add(numberOfMonth-1,'M'),
    currentDate: moment(),
    eventFilter: [],
    productionSeasonFilter: 0,
    filterFunction: () => { return true; },
    events: []

}

let calendarSettings: ICalendarSettings = {
    loadWrappingMonthDates: true,
    saveHistory: false
};

createCalendarStore(defaultState, calendarSettings);

render(
    <Provider store={CalendarActions.calendarStore()}>
        <div>
            <App numberOfMonth={numberOfMonth <= 0 ? 5 : numberOfMonth} />
        </div>
    </Provider>

    , document.getElementById("calendar-entry-js"));

// ------------------------------------------------------------ //
// ------- For calendar grid alignment on large screens ------- //
// ------------------------------------------------------------ //

let nav = document.querySelector(".header-navbar-inner-js") as HTMLElement;
let navWidth = nav.offsetWidth;
let bodyWidth = document.body.clientWidth;
let calGrid = document.querySelector(".cal-grid-container") as HTMLElement;
let calNav = document.querySelector(".cal-filters-inner"); 

if (bodyWidth > 1600) {
    calGrid.style.marginRight = ((bodyWidth - navWidth) / 2) + "px";
}

window.addEventListener("resize", function () {
    bodyWidth = document.body.clientWidth;
    if (bodyWidth > 1600) {
        navWidth = nav.offsetWidth;
        calGrid.style.marginRight = ((bodyWidth - navWidth) / 2) + "px";
    }
    else {
        calGrid.removeAttribute("style");
    }
})

stickyfill.add(calNav);


// WEBPACK FOOTER //
// ./app/calendar/index.tsx